import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=36e94d62&"
import script from "./SelectView.vue?vue&type=script&lang=js&"
export * from "./SelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports